<!-- Tres paneles en fila (Pagos · Mora · Factura) y «Movimientos de la letra» a todo lo ancho debajo -->
<div class="pd-detail">
  <div class="pd-grid">
    <!-- 1 · Pagos: una tarjeta por pago en tres bloques (quién y cuánto · fechas · reparto por concepto);
         toda la tarjeta abre el cajón -->
    <div class="pd-pays-cell">
      <section class="pd-panel">
        <h4>
          Pagos aplicados a la letra {{ period.n }}
          <span class="pd-tag is-soft">{{ liveApplications.length }}</span>
          <span class="pd-right" *ngIf="isNextToCollect && unapplied.length">
            <ng-container *appIfHasPermission="['applications', 'create']">
              <button type="button" class="pd-textbtn" (click)="apply.emit()"><i class="pi pi-play"></i> Aplicar un pago aquí</button>
            </ng-container>
          </span>
        </h4>
        <div class="pd-chips" *ngIf="driftChips.length || isResidue">
          <span *ngFor="let c of driftChips" class="enf-chip" [class.is-danger]="c.tone === 'danger'">{{ c.label }}</span>
          <span
            *ngIf="isResidue"
            class="enf-chip is-muted"
            tabindex="0"
            aria-label="Residuo de 10 pesos o menos: no devenga ni entra a cobranza automática, pero se debe y cuenta en cartera"
            pTooltip="Residuo ≤ $10: no devenga ni entra a cobranza automática, pero se debe y cuenta en cartera"
            tooltipPosition="top"
            >residuo</span
          >
        </div>
        <div class="pd-plist" *ngIf="period.applications.length; else sinPagos">
          <article
            *ngFor="let a of period.applications"
            class="pd-pay"
            [class.is-cancelled]="a.status === 'CANCELLED'"
            role="button"
            tabindex="0"
            [attr.aria-label]="'Abrir el pago ' + a.trackingKey"
            (click)="openPayment.emit(a.paymentId)"
            (keydown.enter)="openPayment.emit(a.paymentId)"
            (keydown.space)="openPayment.emit(a.paymentId); $event.preventDefault()"
          >
            <header class="pd-pay-h">
              <span class="pd-pay-id">
                <span class="pd-pay-key pd-mono">{{ a.trackingKey }}</span>
                <span class="pd-pay-meta">{{ a.account || 'sin cuenta' }}</span>
              </span>
              <span class="pd-pay-amt">
                {{ a.amount | currency }}
                <small>aplicado a esta letra</small>
              </span>
              <p-tag
                *ngIf="a.status === 'CANCELLED'"
                value="Cancelada"
                severity="danger"
                [pTooltip]="a.cancelReason || ''"
                tooltipPosition="top"
              ></p-tag>
            </header>
            <div class="pd-pay-facts">
              <span class="pd-fact"
                ><span class="pd-fact-l">Pagó el cliente</span
                ><span class="pd-fact-v">{{ a.paidOn | date: 'dd/MM/yyyy' : 'UTC' }}</span></span
              >
              <span class="pd-fact"
                ><span class="pd-fact-l">Registrado</span
                ><span class="pd-fact-v"
                  >{{ a.registeredOn | date: 'dd/MM/yyyy'
                  }}<span *ngIf="daysBetween(a.paidOn, a.registeredOn) as lag" class="pd-lag">+{{ lag }} d</span></span
                ></span
              >
              <span class="pd-fact"
                ><span class="pd-fact-l">Aplicó</span
                ><span class="pd-fact-v" [attr.title]="(a.appliedBy || '—') + ' · ' + (a.appliedOn | date: 'dd/MM/yyyy')"
                  >{{ firstName(a.appliedBy) }} · {{ a.appliedOn | date: 'dd/MM/yyyy' }}</span
                ></span
              >
            </div>
            <div class="pd-pay-split">
              <span
                class="pd-split"
                *ngFor="let k of conceptKeys(a.byConcept)"
                [class.is-mora]="k === 'moratoriums'"
                [class.is-zero]="!a.byConcept[k]"
              >
                <span class="pd-split-l">{{ conceptLabels[k] || k }}</span>
                <span class="pd-split-v">{{ a.byConcept[k] || 0 | currency }}</span>
              </span>
            </div>
          </article>
        </div>
        <ng-template #sinPagos>
          <p class="pd-empty" *ngIf="coveredByDownPayment; else sinNingunPago">
            Renta anticipada cubierta con el pago inicial ({{ period.applied.total | currency }}).<ng-container *ngIf="period.pending > 0">
              Quedan {{ period.pending | currency }} por cobrar al vencimiento de la letra.</ng-container
            >
          </p>
          <ng-template #sinNingunPago><p class="pd-empty">Sin pagos aplicados a esta letra.</p></ng-template>
        </ng-template>
      </section>
    </div>

    <!-- 2 · Mora: estado, cifras, línea de tiempo con hitos y tramos, y «Condonar» (F28) -->
    <section class="pd-panel">
      <h4>
        Mora
        <p-tag
          [value]="moraState.label"
          [severity]="moraState.severity"
          [icon]="moraState.label === 'en pausa' ? 'pi pi-pause' : undefined"
        ></p-tag>
        <!-- El botón vive aquí y abre el editor con esta letra ya elegida; nunca condona solo -->
        <span class="pd-right" *ngIf="period.mora.balance > 0">
          <ng-container *appIfHasPermission="['leases', 'edit-amounts']">
            <button type="button" class="pd-textbtn" (click)="waive.emit(period.n)"><i class="fa-solid fa-handshake"></i> Condonar</button>
          </ng-container>
        </span>
      </h4>

      <!-- Abierta y cerrada no se preguntan lo mismo: una, cuánto va a crecer; la otra, cuánto costó. -->
      <dl class="pd-kv" *ngIf="period.pending > 0; else moraCerrada">
        <dt>Días vencida</dt>
        <dd [class.is-bad]="period.mora.days > 0">{{ period.mora.days }}</dd>
        <dt>Saldo que devenga hoy</dt>
        <dd>{{ period.mora.balance | currency }}</dd>
        <dt>Mora diaria ({{ period.mora.rate * 100 | number: '1.1-1' }} % mensual ÷ 30)</dt>
        <dd>{{ period.mora.daily | currency }}</dd>
        <dt>Devengada a hoy</dt>
        <dd [class.is-bad]="period.mora.accrued > 0">{{ period.mora.accrued | currency }}</dd>
        <ng-container *ngIf="period.mora.paid > 0"
          ><dt>Cobrada</dt>
          <dd class="is-good">{{ period.mora.paid | currency }}</dd></ng-container
        >
        <ng-container *ngIf="period.mora.waived > 0"
          ><dt>Condonada</dt>
          <dd>{{ period.mora.waived | currency }}</dd></ng-container
        >
      </dl>
      <ng-template #moraCerrada>
        <dl class="pd-kv">
          <dt>Días de retraso</dt>
          <dd>{{ period.delayDays || 0 }}</dd>
          <dt>Mora cobrada</dt>
          <dd class="is-good">{{ period.mora.paid | currency }}</dd>
          <dt>Mora condonada</dt>
          <dd>{{ period.mora.waived | currency }}</dd>
          <dt>Registro tardío</dt>
          <dd [class.is-bad]="(period.registrationLagDays || 0) > 0">
            {{ period.registrationLagDays ? '+' + period.registrationLagDays + ' d' : 'sin desfase' }}
          </dd>
        </dl>
      </ng-template>

      <!-- Línea de tiempo: vencimiento, cuándo pagó, cuánto tardamos en registrarlo y hoy -->
      <svg class="pd-tl" viewBox="0 0 400 74" preserveAspectRatio="none" role="img" aria-label="Línea de tiempo de la letra">
        <rect
          *ngIf="moraChart.overdueBand"
          [attr.x]="moraChart.overdueBand.x"
          y="31"
          [attr.width]="moraChart.overdueBand.width"
          height="18"
          fill="rgba(210,19,19,.12)"
        ></rect>
        <rect
          *ngFor="let b of moraChart.lagBands"
          [attr.x]="b.x"
          y="31"
          [attr.width]="b.width"
          height="18"
          fill="rgba(245,158,11,.18)"
        ></rect>
        <line x1="22" y1="40" x2="378" y2="40" stroke="#e9ecef" stroke-width="2"></line>
        <line [attr.x1]="moraChart.due.x" y1="26" [attr.x2]="moraChart.due.x" y2="54" stroke="#202835" stroke-width="2"></line>
        <text [attr.x]="moraChart.due.x" y="22" font-size="9" text-anchor="middle" fill="#202835" font-weight="600">
          {{ moraChart.due.label }}
        </text>
        <ng-container *ngFor="let p of moraChart.paids">
          <circle [attr.cx]="p.x" cy="40" r="4.5" fill="#3b82f6" stroke="#fff" stroke-width="2"></circle>
          <text [attr.x]="p.x" y="64" font-size="9" text-anchor="middle" fill="#1d4ed8" font-weight="600">{{ p.label }}</text>
        </ng-container>
        <ng-container *ngFor="let r of moraChart.registers">
          <circle [attr.cx]="r.x" cy="40" r="3.5" fill="#fff" stroke="#f59e0b" stroke-width="2"></circle>
          <text [attr.x]="r.x" y="34" font-size="8.5" text-anchor="middle" fill="#92400e">{{ r.label }}</text>
        </ng-container>
        <ng-container *ngIf="moraChart.today">
          <line
            [attr.x1]="moraChart.today.x"
            y1="28"
            [attr.x2]="moraChart.today.x"
            y2="52"
            stroke="#d21313"
            stroke-width="2"
            stroke-dasharray="3 2"
          ></line>
          <text [attr.x]="moraChart.today.x" y="64" font-size="9" text-anchor="end" fill="#d21313" font-weight="600">
            {{ moraChart.today.label }}
          </text>
        </ng-container>
      </svg>

      <!-- Tramos de moraAsOf (PRD §8.1): días · base · lo que creció en cada uno -->
      <p class="pd-tramos" *ngIf="period.mora.tramos?.length">
        <span *ngFor="let t of period.mora.tramos">{{ t.days }} d sobre {{ t.base | currency }} → +{{ t.accrued | currency }}</span>
      </p>
      <p class="pd-empty" *ngIf="period.mora.balance < 0">
        <i class="pi pi-info-circle"></i> Mora cobrada de más por un pago fuera de orden: cancela la aplicación posterior y vuelve a aplicar
        por fecha.
      </p>
    </section>

    <!-- 3 · Factura -->
    <section class="pd-panel">
      <h4>
        Factura
        <p-tag
          *ngIf="period.invoice.active as inv"
          [value]="inv.status === 'PENDING_FILES' ? 'sin archivos' : inv.paymentType || 'ligada'"
          [severity]="inv.status === 'PENDING_FILES' ? 'warning' : 'info'"
        ></p-tag>
      </h4>
      <dl class="pd-kv" *ngIf="period.invoice.active as inv; else sinFactura">
        <dt>Folio fiscal</dt>
        <dd class="pd-mono">{{ inv.folioFiscal || inv.uid || '—' }}</dd>
        <dt>Método</dt>
        <dd>{{ inv.paymentType || '—' }}</dd>
        <dt>Estatus</dt>
        <dd>{{ inv.status === 'PENDING_FILES' ? 'Referencia sin archivos' : 'Ligada' }}</dd>
        <dt>Pago</dt>
        <dd [class.is-good]="period.pending <= 0">{{ period.pending > 0 ? 'Pendiente' : 'Pagada' }}</dd>
        <ng-container *ngIf="inv.paymentType === 'PPD'">
          <dt>Complemento (REP)</dt>
          <dd
            [class.is-good]="inv.complementStatus === 'RECEIVED'"
            [class.is-bad]="inv.complementStatus === 'PENDING' && period.pending <= 0"
          >
            {{ inv.complementStatus === 'RECEIVED' ? 'Recibido' : period.pending > 0 ? 'Se pide al pagar' : 'Pendiente' }}
          </dd>
        </ng-container>
        <ng-container *ngIf="period.invoice.history?.length">
          <dt>Historial</dt>
          <dd>{{ period.invoice.history.length }} factura(s)</dd>
        </ng-container>
      </dl>
      <ng-template #sinFactura><p class="pd-empty">Sin factura vigente.</p></ng-template>
    </section>
  </div>

  <!-- 4 · Movimientos de la letra: a todo lo ancho, debajo de los tres paneles -->
  <section class="pd-panel pd-events-block">
    <h4>Movimientos de la letra</h4>
    <div class="pd-events" *ngIf="period.events.length; else sinMovimientos">
      <div class="pd-ev" *ngFor="let e of period.events">
        <span class="pd-ev-dt">{{ e.date | date: 'dd/MM/yyyy' }}</span>
        <span class="pd-ev-dot" [ngClass]="'is-' + eventTone(e.type)" aria-hidden="true"></span>
        <span
          ><b>{{ eventLabels[e.type] || e.type }}</b
          ><span class="pd-ev-who" *ngIf="e.user"> · {{ e.user }}</span></span
        >
      </div>
    </div>
    <ng-template #sinMovimientos><p class="pd-empty">Sin movimientos.</p></ng-template>
  </section>
</div>
